import { useParams } from "react-router-dom";
import useRestaurantMenu from "../utils/useRestaurantMenu";
import ShimmerCard from "./ShimmerCard";


const RestaurentMenu = () => { 
    const {resId} = useParams();
    const resInfo = useRestaurantMenu(resId);
    if(resInfo === null) return <ShimmerCard/>
    // const {itemCards} = resInfo;
    return (
        <div> 
            <h1>Name of Restaurent : {resInfo?.cards[0]?.card?.card?.text}</h1>
            {/* {itemCards.map((item) => (
                <li key={item?.card?.info?.name}> {item?.card?.info?.name + "- Rs. " + item?.card?.info?.price/100} </li>
            ))} */}
        </div>
    )
}

export default RestaurentMenu;